interface SeverityRange {
  min: number;
  max: number;
  label: string;
}

const mapScoreToSeverity: Record<string, SeverityRange[]> = {
  "GAD-7": [
    { min: 0, max: 4, label: "Minimal" },
    { min: 5, max: 9, label: "Mild" },
    { min: 10, max: 14, label: "Moderate" },
    { min: 15, max: 21, label: "Severe" },
  ],
  "PHQ-9": [
    { min: 0, max: 4, label: "Minimal" },
    { min: 5, max: 9, label: "Mild" },
    { min: 10, max: 14, label: "Moderate" },
    { min: 15, max: 19, label: "Moderately Severe" },
    { min: 20, max: 27, label: "Severe" },
  ],
};

export const getSeverity = (type: string, score: number) => {
  const ranges = mapScoreToSeverity[type];

  if (!ranges) return null;

  const match = ranges.find((r) => score >= r.min && score <= r.max);

  return match?.label ?? "";
};
